import { BadgeSizes } from "./types"
import { BadgeWrapper } from "./BadgeWrapper"

const FeaturedBadgeIcon = ({ iconSize = 16 }: { iconSize: number }) => {
  return (
    <span className="d-if ai-c jc-c mr-4p">
      <svg
        role="img"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width={iconSize}
        height={iconSize}
        viewBox="0 0 16 16"
        className="featured-badge__icon"
        style={{ fill: "currentcolor" }}
      >
        <path d="m8 .5 2.472 4.937L16 6.23l-4 3.843.944 5.427L8 12.937 3.056 15.5 4 10.073 0 6.229l5.528-.793L8 .5Z" />
      </svg>
    </span>
  )
}

export interface FeaturedBadgeProps {
  size?: BadgeSizes
}

const Featured = ({ size = "md" }: FeaturedBadgeProps) => {
  return (
    <BadgeWrapper size={size} theme="featured">
      <FeaturedBadgeIcon iconSize={size === "sm" ? 10 : 14} />
      Featured
    </BadgeWrapper>
  )
}

Featured.displayName = "Badge.Featured"

export { Featured }
